import { render } from "./UserTagHistoryView.vue?vue&type=template&id=2d68268e"
import script from "./UserTagHistoryView.vue?vue&type=script&lang=js"
export * from "./UserTagHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__